import React from 'react'
import { IVideo } from 'shared/types/video'
import styled, { css } from 'styled-components'
import { giphyDarkestGrey, giphyDarkGrey, giphyWhite } from '@giphy/js-brand'
import { googleAnalyticsEvent } from 'shared/util/analytics'
import { getFavicon } from 'shared/util/url'

const CTAContainer = styled.div`
    height: 42px;
    background: linear-gradient(90deg, ${giphyDarkestGrey} 0%, ${giphyDarkGrey} 100%);
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 15px;
    font-weight: bold;
    color: ${giphyWhite};
    margin: 8px;
`

const TextWrapper = styled.div`
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    max-width: 290px;
`

const FaviconContainer = styled.div<{ hasFavicon: boolean }>`
    text-align: center;
    margin: 0px 10px 0px 0px;

    ${props =>
        props.hasFavicon &&
        css`
            margin: 0px 10px 6px 0px;
        `}
`

const Favicon = styled.img`
    width: 16px;
    height: 16px;
    vertical-align: bottom;
`
const Icon = styled.div`
    color: white;
    margin: 5px 0px 2px 5px;
`

type Props = {
    gif: IVideo
}

const MobileCTA = ({ gif }: Props) => {
    const { text, link } = gif.cta || { text: '', link: '' }
    const favicon = getFavicon(link)

    const ctaClick = (gifID: string) => {
        googleAnalyticsEvent({
            category: 'Gif detail',
            action: 'CTA Click',
            label: gifID,
        })
    }

    return (
        <>
            {text && link && (
                <a href={link} target="_blank" rel="noreferrer" onClick={() => ctaClick(String(gif.id))}>
                    <CTAContainer>
                        <FaviconContainer hasFavicon={Boolean(favicon)}>
                            {favicon ? <Favicon src={favicon} /> : <Icon className="ss-icon ss-globe" />}
                        </FaviconContainer>
                        <TextWrapper>{text}</TextWrapper>
                    </CTAContainer>
                </a>
            )}
        </>
    )
}

export default MobileCTA
